import { render, staticRenderFns } from "./repayment.vue?vue&type=template&id=40a30e3a&"
import script from "./repayment.vue?vue&type=script&lang=js&"
export * from "./repayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports